module.exports = __webpack_public_path__ + "static/media/header_icon.5d16a32e.png";